var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStepperInactive = function SvgIconStepperInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9 17.333A8.333 8.333 0 1 1 9 .667a8.333 8.333 0 0 1 0 16.666m0-1.666A6.667 6.667 0 1 0 9 2.334a6.667 6.667 0 0 0 0 13.333"
  })));
};
export default SvgIconStepperInactive;